<page-title text="Digital Currency Prices | BitOasis" i18n-text="@@pageTitle.pricesPage"></page-title>
<page-meta
    description="Explore digital assets on BitOasis. Check prices, charts and descriptions of Bitcoin, Ethereum and more."
    i18n-description="@@pageMeta.description.pricesPage">
</page-meta>
<site-layout>
  <div class="wrapper">
    <nav class="breadcrumb p-3" aria-label="breadcrumb">
        <a routerLink="/home" i18n="@@breadcrumb.front.home">Home</a>
        <div class="separator"></div>
        <span i18n="@@breadcrumb.front.prices">Prices</span>
    </nav>
    <div class="box">
        <crypto-prices></crypto-prices>
    </div>
  </div><!-- .wrapper -->
</site-layout>
<site-footer></site-footer>